import { Link } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";
import { appConfig } from "../../utils/config";
import { useSafeLogin } from "../../hooks/auth/useSafeLogin";
import "./SessionExpired.css";

export default function SessionExpired() {
  const { signinRedirect, isLoading } = useAuth();
  const { t } = useTranslation();
  const headerLogo = appConfig.logoFourth || appConfig.logo;
  const { login, isLoginPending } = useSafeLogin({
    isLoading,
    signinRedirect,
    t,
    brand: appConfig.brandTheme,
  });

  return (
    <main className="session-expired-page">
      <section className="session-expired-panel">
        {headerLogo && (
          <img
            className="session-expired-logo"
            src={headerLogo}
            alt={t(`clients.${appConfig.client}.title`)}
          />
        )}
        <h1 className="session-expired-title">
          {t("sessionExpired.title")}
        </h1>
        <p className="session-expired-text">{t("sessionExpired.message")}</p>
        <div className="session-expired-actions">
          <button
            type="button"
            className="session-expired-button"
            disabled={isLoading || isLoginPending}
            onClick={() => login()}
          >
            {isLoading || isLoginPending
              ? t("sessionExpired.loading")
              : t("sessionExpired.login")}
          </button>
          <Link className="session-expired-link" to="/">
            {t("sessionExpired.home")}
          </Link>
        </div>
      </section>
    </main>
  );
}
